// extracted by mini-css-extract-plugin
export var title = "TrailersSection-module--title--eab0e";
export var video = "TrailersSection-module--video--94b22";
export var videoWrapper = "TrailersSection-module--videoWrapper--2b357";
export var wrapper = "TrailersSection-module--wrapper--9f595";